<template>
  <div>
    <img src="../assets/logo2.png" class="logo" />
    <div class="text">{{langConfig[langKey].tip}}</div>
  </div>
</template>

<script>
export default {
  name: "SuccessPage",
  data() {
    return {
      langKey:"ch",
      langConfig: {
        en:{
           tip:"Congratulations, submitted successfully"
        },
        ch:{
          tip:"恭喜您，提交成功"
        }
      }
    };
  },
  created(){
    console.log(">>>>>>",this.$route.query.lang)
    const langKey=this.$route.query.lang
    if(langKey){
       this.langKey=this.$route.query.lang
    }
   
  }
};
</script>

<style>
.logo {
  width: 3.75rem;
  margin-top: 1.2rem;
  margin-bottom: 0.6rem;
}
.text{
   margin-top: 1.2rem;
   color: #1160F1;
   font-size: 0.3rem;
}
</style>



// WEBPACK FOOTER //
// src/components/SuccessPage.vue